import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';

export const InfoModalTestReport = ({ props, setShowModal, showModal, message }) => {

    const recarga = () => {
        window.location.reload();
    }

    const { className } = props;

    return (
        <Modal
            isOpen={showModal}
            modalTransition={{ timeout: 100 }}
            backdropTransition={{ timeout: 300 }}
            toggle={() => setShowModal(!showModal)}
            size='m'
            className={className}
            centered
        >
            <div className='d-flex ms-3 p-0 align-items-center mt-3'>
                <span className="mdi mdi-alert-outline mdi-36px text-warning ps-4 m-0"></span>
                <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>Mensaje</h4></label>
            </div>

            <hr style={{ background: 'linear-gradient(to right, #94C12E,#04BBF1 ,#1D4370)', height: 4 }} />


            <ModalBody>
                <div className='px-4'>
                    <label for="exampleInputEmail1" className='text-primary'>{message}</label>
                    <br />
                </div>

            </ModalBody>

            <hr style={{ background: 'linear-gradient(to right, #94C12E,#04BBF1 ,#1D4370)', height: 4 }} />

            <div className="page-title-box d-flex justify-content-end">

                <Button outline color="primary" className='rounded-3 me-3 p-2' onClick={() => {setShowModal(false); setTimeout(recarga, 900);  }}>
                    <span className="mdi mdi-18px mdi-checkbox-marked-circle me-1"></span>Aceptar
                </Button>

            </div>
        </Modal>


    )

}
